/**
 * @generated SignedSource<<43bed496f79dbcd4ff14308c623f74ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueResults_issueResults$data = {
  readonly issueSearchError: {
    readonly __typename: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_DetailView_issueResults" | "main_issueNavigator_ListView_issueResults">;
  readonly " $fragmentType": "main_issueNavigator_IssueResults_issueResults";
};
export type main_issueNavigator_IssueResults_issueResults$key = {
  readonly " $data"?: main_issueNavigator_IssueResults_issueResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueResults_issueResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueResults_issueResults",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        }
      ],
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_ListView_issueResults"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_DetailView_issueResults"
    },
    {
      "kind": "LinkedField",
      "name": "issueSearchError",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "954e440266f74e27a737f33326b3732e";

export default node;
